<template>
  <div
    :class="{
      container:
        !parentType &&
        fieldListType !== 'menu' &&
        fieldListType !== 'footerCta',
    }"
  >
    <ZtLink
      :to="link?.uri?.path"
      :data-track-id="uuid"
      :class="{
        'link text-prose': !isButton,
        'with-arrow': !isButton && fieldListType !== 'footerLinks',
        'button is-primary w-full': isButton,
        'is-grey text-size-6': fieldListType === 'footerLinks',
        'text-size-5': fieldListType === 'menu',
      }"
      @click="onClick"
    >
      {{ title }}
    </ZtLink>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphLinkFragment } from '#graphql-operations'

const props = defineProps<{
  link?: ParagraphLinkFragment['link']
  customBehaviour?: ParagraphLinkFragment['customBehaviour']
}>()

const { fieldListType, uuid, parentType } = defineBlokkli({
  bundle: 'link',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const isButton = computed(() => fieldListType.value === 'footerCta')

const title = computed(() => {
  if (props.link?.title) {
    return props.link.title
  }

  const url = props.link?.uri

  if (url && 'entity' in url && url.entity?.label) {
    return url.entity.label
  }

  return ''
})

const onClick = (e: MouseEvent) => {
  if (props.customBehaviour) {
    e.preventDefault()
    try {
      // eslint-disable-next-line sonarjs/code-eval
      new Function(props.customBehaviour)()
    } catch (err) {
      console.error('Custom behaviour error:', err)
    }
  }
}
</script>
